import { useWeb3React } from '@web3-react/core'
import BigNumber from 'bignumber.js'
import { useFastRefreshEffect, useSlowRefreshEffect } from 'hooks/useRefreshEffect'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'state'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useXpMerchantContract } from 'hooks/useContract'
import { deserializeToken } from 'state/user/hooks/helpers'
import { BIG_ZERO } from 'utils/bigNumber'
import { getBalanceAmount } from 'utils/formatBalance'
import { fetchXpMerchantPublicDataAsync } from '.'
import { DeserializedXpMerchant, DeserializedXpMerchantState, SerializedXpMerchant, State } from '../types'

const deserializeXpMerchantData = (data: SerializedXpMerchant): DeserializedXpMerchant => {
  return {
    xpBalance: data.xpBalance ? new BigNumber(data.xpBalance) : BIG_ZERO,
  }
}

export const useXpMerchant = () => {
  const dispatch = useAppDispatch()
  const { account } = useActiveWeb3React()

  useFastRefreshEffect(() => {
    dispatch(fetchXpMerchantPublicDataAsync(''))
  }, [account, dispatch])
}

export const useXpMerchantData = (): DeserializedXpMerchant => {
  const xpMerchantData = useSelector((state: State) => state.xpMerchant.data)

  if(!xpMerchantData){
    return {
      xpBalance: new BigNumber('0')
    }
  }

  const deserializedXpMerchantData: DeserializedXpMerchant = deserializeXpMerchantData(xpMerchantData)

  return deserializeXpMerchantData(xpMerchantData)
}
